// import $fetch from "../$fetch"
import categoryStore from "../store/CategoryStore"

export default class Auth {
  constructor( { config, shop, signal } ) {
    this.config = config
    this.signal = signal
    this.hasSession = false
    this.shop = shop
    this.login_url = this.config.API + "security/login"
    this.logout_url = this.config.API + "security/logout"
    this.whoami_url = this.config.API + "security/whoami"
    this.whoamiInterval = window.setInterval( () => {
      this.whoami()
    }, 1000 * 30 )
  }
  
  logout() {
    
    return this._sendLogoutRequest()
      .then( console.log("shop.session logout: " , this.shop.session))
      .then( () => this.setSession( false ) )
      .then( () => this.dispatchLogout() )
    
  }
  
  _sendLogoutRequest() {
    return fetch( this.logout_url + "?r=" + Math.random(), {
      mode: "cors", method: "GET", credentials: "include",
    } )
  }
  
  setSession( session ) {
    if ( !session ) {
      return session
    }
    
    if ( session.value == "you are unknown" ) {
      this.shop.session = false
      this.dispatchLogout()
    } else {
      if ( this.shop.SessionModel ) {
        if ( this.shop.session ) {
          // update Session
          Object.assign( this.shop.session, session )
        } else {
          // create new Session
          this.shop.session = new this.shop.SessionModel( session, this.shop )
          
          if ( this.shop.session.handId ) {
            this.configureIHand()
          }
          categoryStore.updateCategories && categoryStore.updateCategories()
        }
      } else {
        this.shop.session = session
      }
      
      if ( !this.hasSession ) {
        console.log( `session`, { session, process } )
        this.signal.dispatch( { session } )
        
        if ( window.trackJs ) {
          window.trackJs.configure( { sessionId: session.session, version: process.env.VERSION, userId: `${session.value.map_id} -  ${session.value.title}` } )
        }
      }
      
      this.hasSession = true
      return session
    }
  }
  
  dispatchLogin( data ) {
    this.shop.events.login.dispatch( data )
    return data
  }
  
  dispatchLogout( data ) {
    this.shop.events.logout.dispatch( data )
    return data
  }
  
  configureIHand() {
    console.log( "Auth: ihand user mode set" )
  }
  
  login( { user, password } ) {
    return fetch( this.login_url, {
      mode: "cors", method: "POST", credentials: "include", body: JSON.stringify( {
        user    : `${user}`.trim(),
        password: `${password}`.trim()
      } )
    } )
      .then( res => res.json() )
    
  }
  
  whoami() {
    return fetch( `${this.whoami_url}?rand=${Math.random()}`, {
      mode: "cors", method: "GET", credentials: "include",
    } )
      .then( res => res.json() )
      .then( session => this.setSession( session ) )
      .then( console.log("whoami Log"))
      .catch( err => {
        console.error( err )
      } )
  }
  
  auth( { user, password } ) {
    // LOGIN: API_SHOP + "security/login",
    //    LOGOUT: API_SHOP + "security/logout",
    //    WHOAMI: API_SHOP + "security/whoami",
    console.log("this.shop.session AUTH",this.shop.session)
    this.shop.cart.reset()
    return this.logout()
      .then( () => {
        return this.login( {
          user, password
        } )
      } )
      .then( res => {
        console.log( `err`, res )
        if ( !res || res && res.result == "error" ) {
          throw("Login fehlgeschlagen")
        }
        if ( res ) {
          return this.whoami( res )
        }
      } )
      .then( session => this.setSession( session ) )
      .then( session => {
        if ( session ) this.dispatchLogin( session )
        return session
      } )
  }

  authOrfix( { user, password,guest } ) {
    // LOGIN: API_SHOP + "security/login",
    //    LOGOUT: API_SHOP + "security/logout",
    //    WHOAMI: API_SHOP + "security/whoami",
    //console.log("this.shop.session AUTH",this.shop.session, "AUTH - GUEST: ", guest )
    this.shop.cart.reset()
    if(guest == true){
      return this.login( {
        user, password
      } )
      .then( res => {
        console.log( `err`, res )
        if ( !res || res && res.result == "error" ) {
          throw("Login fehlgeschlagen")
        }
        if ( res ) {
          return this.whoami( res )
        }
      } )
      .then( session => this.setSession( session ) )
      .then( session => {
        if ( session ) this.dispatchLogin( session )
        return session
      } )
    }
    else{
      return this.logout()
      .then( () => {
        return this.login( {
          user, password
        } )
      } )
      .then( res => {
        console.log( `err`, res )
        if ( !res || res && res.result == "error" ) {
          throw("Login fehlgeschlagen")
        }
        if ( res ) {
          return this.whoami( res )
        }
      } )
      .then( session => this.setSession( session ) )
      .then( session => {
        if ( session ) this.dispatchLogin( session )
        return session
      } )
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/Auth/Auth.js